import { z } from 'zod'

export const PayPalConfigSchema = z.object({
  live_client_id: z.string(),
  sandbox_client_id: z.string(),
  live_webhook_id: z.string().nullable(),
  sandbox_webhook_id: z.string().nullable(),
})
